import { useState } from "react";
import { connect } from "react-redux";

import {
  Typography,
  TextareaAutosize,
} from "@mui/material";
import MDBox from "../components/MDBox";
import MDInput from "../components/MDInput";
import { handleImageUpload, handleInputChange } from "../components/utilities/HandleChange";
import download from "../assets/images/upload.png";
import LbicButton from "../components/lbic_component/LbicButton";
import { ClientCall } from "../context/allotees/apiClass";

const ClaimReport = ({ allotee, properties }) => {
  const [images, setImages] = useState({files: []});
  const [claimReport,setClaimReport] = useState({owners_name: allotee.owners_name,email: allotee.email})
  const [selectedProperty, setSelectedProperty] = useState("");
  const [location, setLocation] = useState("");
  const [show, setShow] = useState(false);

  const selectProperty = (data) => {
    setShow(false);
    setLocation(data.location);
    setSelectedProperty(data);
    setClaimReport({...claimReport, location: data.location, flat_no: data.flat_number})
  };

  const classes = "black-deep text-center";

  console.log(claimReport)

  const handleClaimReport = () => {
    const claimreportFormdata = new FormData()
    for (const key in claimReport) {
      claimreportFormdata.append([key], claimReport[key])
    }

    for (let index = 0; index < images.files.length; index++) {
      //
      claimreportFormdata.append('img', images.files[index],images.files[index].name)
    }
    ClientCall(claimreportFormdata,'post','/claim-report',null,callback,errcallback,null,'allotee',null)
  }

  const callback = (res) => {
    setClaimReport({})
    setImages([])
  }

  const errcallback = (err) => {
    console.log(err)
  }

  return (
    <div className="normal-container">
      <MDBox className="container-dashboard">
        <MDBox role="form">
          <MDBox className="column">
            <MDBox className="item">
              <MDBox  mb={4}>
                <MDInput
                  type="text"
                  label="Owner's Name"
                  variant="standard"
                  fullWidth
                  onChange={(e) =>
                    handleInputChange(e, setClaimReport, claimReport)
                  }
                  name="owners_name"
                  disabled={true}
                  defaultValue={claimReport.owners_name}
                />
              </MDBox>

              <MDBox mb={4}>
                <p className="small-text" style={{ color: "#7b809a" }}>
                  Property Location
                </p>
                <div
                  className="btn w-100 rounded-3 small-text "
                  style={{
                    backgroundColor: "#e1dfdf",
                    textAlign: "left",
                    color: "#484848",
                    fontWeight: 600,
                  }}
                  onClick={() => (!show ? setShow(true) : setShow(false))}
                >
                  {location !== "" ? location : "Select Property Location"}
                </div>
                {show ? (
                  <div className="w-100 p-1">
                    <ul className="bg-light rounded-3 navbar-nav px-2">
                      {properties.map((item) => (
                        <li
                          className="p-1 my-1 rounded-3 select-hover"
                          style={{
                            backgroundColor: "#e1dfdf",
                            color: "#484848",
                          }}
                          onClick={() => selectProperty(item)}
                        >
                          {item.location}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
              </MDBox>
              {selectedProperty !== "" && !show ? (
                <MDBox mb={4}>
                  <div
                    className="py-2 px-1 mb-2 w-100 fs-5 fw-bolder text-left"
                    style={{ backgroundColor: "#f0f2f5" }}
                  >
                    <span className="fs-6">Location</span>:{" "}
                    {selectedProperty.location}
                  </div>
                  <div
                    className="py-2 px-1 mb-2 w-100 fs-5 fw-bolder text-left"
                    style={{ backgroundColor: "#f0f2f5" }}
                  >
                    <span className="fs-6">Block Number</span>:{" "}
                    {selectedProperty.block_number}
                  </div>
                  <div
                    className="py-2 px-1 mb-2 fs-5 w-100 fw-bolder text-left"
                    style={{ backgroundColor: "#f0f2f5" }}
                  >
                    <span className="fs-6">Flat Number</span>:{" "}
                    {selectedProperty.flat_number}
                  </div>
                </MDBox>
              ) : null}

              <MDBox mb={4}>
                <Typography className="fw-light small-text mb-2">Description</Typography>
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={3}
                  placeholder="Write description"
                  style={{ width: "100%"}}
                  onChange={(e) =>
                    handleInputChange(e, setClaimReport, claimReport)
                  }
                  name="description"
                />
              </MDBox>
              <MDBox mb={4}>
              <Typography className="fw-light small-text mb-1">Date of Occurence</Typography>
                  <MDInput
                    type="date"
                    variant="standard"
                    fullWidth
                    onChange={(e) => handleInputChange(e, setClaimReport, claimReport)}
                    name="date_of_occurence"
                  />
                </MDBox>
            <MDBox mb={3}>
                  <MDInput
                    type="number"
                    label="Estimated Amount to Repair"
                    variant="standard"
                    fullWidth
                    onChange={(e) => handleInputChange(e, setClaimReport, claimReport)}
                    name="estimate_of_repair"
                  />
            </MDBox>
            </MDBox >
            <MDBox className="item">
            <MDBox className="upload-container" py={3} px={3}>
                  <MDBox>
                    <MDBox className="upload-holder d-flex flex-column align-items-center">
                      <img src={download} />
                      <input
                        type="file"
                        multiple
                        className="upload-btn"
                        name="img"
                        onChange={(e) => handleImageUpload(e,setImages,images)}
                      />
                    </MDBox>
                    <MDBox>
                      <Typography
                        className={
                          images
                            ? "small-text " + classes
                            : "medium-text " + classes
                        }
                      >
                        Browse File to upload
                      </Typography>
                      <Typography className="small-text black-medium text-center">
                        File Supported: PNG,JPEG,JPG
                      </Typography>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox style={{ marginRight: "2px", padding: "5px 2px",overflow: "hidden" }}>
                  {images.files !== undefined ? images.files.map((image) => (<img src={URL.createObjectURL(image)} className="image-card" />)) : null}
                </MDBox>
              </MDBox>
          </MDBox>
          
            <MDBox>
              <LbicButton
                  onClick={handleClaimReport}
                  title="Submit"
                  color="success"
                  className='button-center'
              />
            </MDBox>

        </MDBox>
      </MDBox>
    </div>
  );
};

export default connect((state) => ({
  allotee: state.alloteeReducer.currentUser,
  properties: state.alloteeReducer.properties,
}))(ClaimReport);
